import { useTranslation } from "hhn-commons";
import { Typography } from "@mui/material";
import LocationAutocomplete from "../calendar/calendarMap/LocationAutocomplete";
import { mapID } from "../addMember/addUsers/advanceSearch/map/AdvanceMapHelper";
import { GeocodeStatus } from "./useGeocodedAddress";

interface CareMapHeaderContentProps {
  formattedAddress: string;
  onPlaceSelected: (place: google.maps.places.PlaceResult | null) => void;
  hasSearched: boolean;
  geocodeStatus: GeocodeStatus;
}

const CareMapHeaderContent = ({
  formattedAddress,
  onPlaceSelected,
  hasSearched,
  geocodeStatus,
}: CareMapHeaderContentProps) => {
  const { t } = useTranslation();
  const tNAdvanceSearch = (key: string) => t(key, { ns: "advanceSearch" });

  return (
    <>
      <LocationAutocomplete
        onPlaceSelected={onPlaceSelected}
        label={tNAdvanceSearch("searchAddress")}
        placeholder={tNAdvanceSearch("searchAddressPlaceholder")}
        value={formattedAddress}
        mapId={mapID}
      />
      {geocodeStatus === "loading" && (
        <Typography variant="caption" sx={{ color: "text.secondary" }}>
          {tNAdvanceSearch("locatingAddress")}
        </Typography>
      )}
      {geocodeStatus === "notFound" && (
        <Typography variant="caption" sx={{ color: "error.main" }}>
          {tNAdvanceSearch("addressNotFound")}
        </Typography>
      )}
      {hasSearched && (
        <Typography variant="caption" sx={{ color: "text.secondary" }}>
          {formattedAddress}
        </Typography>
      )}
    </>
  );
};

export default CareMapHeaderContent;
